//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

export function useSaveClientProduct() {
  const saveClientProduct = async (data: any) => {
    const response = await fetch(`${API_URL}/clients/save_client_product`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return response.json();
  };

  return { saveClientProduct };
}
